import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpUtils} from '../../shared/http-utils';
import {Observable} from 'rxjs';
import {URL_BASE} from '../../core/constants';
import {map} from 'rxjs/operators';
import {SearchObjectResult} from '../../shared/search-object-result.model';
import {EtaDetail} from './eta-detail.model';
import {StopType} from '../../shared/stop-type.model';

@Injectable()
export class EtaDetailsService {

  private TRIPS_URI = 'trips';
  private DELIVERY_URI = 'deliveries';

  constructor(private http: HttpClient) {
  }

  public searchByTripId(
    tripId: String,
    etaDestinationStopType: StopType,
    page: number,
    size: number,
    etaDestinationGlid: string = null
  ): Observable<SearchObjectResult<EtaDetail>> {
    const { headers, params } = this.prepareSearchRequest(etaDestinationStopType, etaDestinationGlid, page, size);

    const url = `${URL_BASE}/api/${this.TRIPS_URI}/${tripId}/etas`;
    return this.http.get(url, { headers, params })
      .pipe(
        map(result => SearchObjectResult.fromDto(result, EtaDetail.fromDto))
      );
  }

  public searchByDeliveryNumber(
    deliveryNumber: String,
    etaDestinationStopType: StopType,
    page: number,
    size: number,
    etaDestinationGlid: string = null
  ): Observable<SearchObjectResult<EtaDetail>> {
    const { headers, params } = this.prepareSearchRequest(etaDestinationStopType, etaDestinationGlid, page, size);

    const url = `${URL_BASE}/api/${this.DELIVERY_URI}/${deliveryNumber}/etas`;
    return this.http.get(url, { headers, params })
      .pipe(
        map(result => SearchObjectResult.fromDto(result, EtaDetail.fromDto))
      );
  }

  private prepareSearchRequest(etaDestinationType: StopType, etaDestinationGlid: string, page: number, size: number) {

    const headers = HttpUtils.createHeaders();
    const params  = {
      page: String(page),
      size: String(size),
      etaDestinationType: etaDestinationType ? etaDestinationType : StopType.Drop,
      ...(etaDestinationGlid != null && { etaDestinationGlid })
    };
    return { headers, params };
  }

}
